<template>
    <div
        class="skill-node"
        :class="[archetypeClass(skill.archetype), skill.shape, state]"
        style="cursor: pointer"
        @click="handleClick"
    >
        <div>
            <p v-if="skill.path === 'None'"><em>All Paths</em></p>
            <p v-else>
                <em>{{ skill.path }}</em>
            </p>
            <h5>{{ skill.name }}</h5>
            <p>{{ state.charAt(0).toUpperCase() + state.slice(1) }}</p>
            <p>Tier {{ skill.tier }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ["skill", "state"],
    methods: {
        archetypeClass(archetype) {
            const key = String(archetype || "")
                .toLowerCase()
                .trim()
                .replace(/^the\s+/, "").replace(/\s+/g, "");

            const map = {
                warrior: "archetype-warrior",
                maverick: "archetype-maverick",
                scholar: "archetype-scholar",
                socialite: "archetype-socialite",
                fool: "archetype-fool",
                weird: "archetype-weird",
                survivor: "archetype-survivor",
                construct: "archetype-construct",
                changed: "archetype-changed",
                madgenius: "archetype-mad-genius",
                immortal: "archetype-immortal",
                luckydevil: "archetype-lucky-devil",
                oddlyundead: "archetype-oddly-undead",
            };

            return map[key] || "archetype-generic";
        },
        handleClick() {
            this.$emit("skill-clicked", this.skill, this.state);
        },
    },
};
</script>

<style scoped>
h5 {
    margin: 0;
    font-weight: 900;
}

p {
    margin: 0;
}

.skill-node {
    border: 2px solid transparent;
    padding: 0.6rem 0.8rem; /* reduced from 0.75rem 1rem (~20% smaller) */
    border-radius: 8px;
    width: 120px;           /* reduced from 150px (~20% smaller) */
    text-align: center;
    font-weight: 500;
    font-size: 0.9rem;      /* slightly smaller text */
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Even smaller on mobile (≤768px) */
@media (max-width: 768px) {
    .skill-node {
        width: 90px;        /* ~60% of original 150px */
        padding: 0.4rem 0.6rem;
        font-size: 0.75rem;
    }
}


/* Archetype color themes */
.archetype-warrior, .archetype-construct {
    background: #ee8a3b;
    border-color: #ee8a3b;
    color: #000;
}
.archetype-maverick, .archetype-changed {
    background: #81c7ff; /* light blue */
    border-color: #81c7ff;
    color: #000;
}
.archetype-scholar, .archetype-mad-genius {
    background: #fff05a; /* yellow */
    border-color: #fff05a;
    color: #000;
}
.archetype-socialite, .archetype-immortal {
    background: #ee001f; /* red */
    border-color: #ee001f;
    color: #fff;
}
.archetype-fool, .archetype-lucky-devil {
    background: #73bd69; /* green */
    border-color: #73bd69;
    color: #000;
}
.archetype-weird, .archetype-oddly-undead {
    background: #8c4796; /* purple */
    border-color: #8c4796;
    color: #000;
}
.archetype-survivor, .archetype-slayer {
    background: #a9a9a9; /* light gray */
    border-color: #a9a9a9;
    color: #000;
}
.archetype-generic {
    background: #444;
    border-color: #222;
    color: #000;
}
.available {
    cursor: pointer;
    filter: brightness(75%);
}
.unavailable {
    cursor: not-allowed;
    filter: grayscale(100%) brightness(60%);
}
.diamond {
    text-align: center;
    height: 100%;
    width: 100%;
    -webkit-mask-image: url("@/../public/img/diamond.svg");
    mask-image: url("@/../public/img/diamond.svg");
    -webkit-mask-size: 100% 100%;
    mask-size: 100% 100%;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
}
.rectangle {
    text-align: center;
    height: 100%;
    width: 100%;
    -webkit-mask-image: url("@/../public/img/rectangle.svg");
    mask-image: url("@/../public/img/rectangle.svg");
    -webkit-mask-size: 100% 100%;
    mask-size: 100% 100%;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
}
.hexagon {
    text-align: center;
    height: 100%;
    width: 100%;
    -webkit-mask-image: url("@/../public/img/hexagon.svg");
    mask-image: url("@/../public/img/hexagon.svg");
    -webkit-mask-size: 100% 100%;
    mask-size: 100% 100%;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
}
.oval-warrior {
    background-color: transparent;
    border-color: transparent;
    text-align: center;
    height: 100%;
    width: 100%;
    color: #fff;
    /* background-color: #ef8b3c; */
    background-image: url("@/../public/img/oval-warrior.svg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
}
.oval-maverick {
    background-color: transparent;
    border-color: transparent;
    text-align: center;
    height: 100%;
    width: 100%;
    color: #fff;
    /* background-color: #ef8b3c; */
    background-image: url("@/../public/img/oval-maverick.svg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
}
.oval-scholar {
    background-color: transparent;
    border-color: transparent;
    text-align: center;
    height: 100%;
    width: 100%;
    color: #fff;
    /* background-color: #ef8b3c; */
    background-image: url("@/../public/img/oval-scholar.svg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
}
.oval-socialite {
    background-color: transparent;
    border-color: transparent;
    text-align: center;
    height: 100%;
    width: 100%;
    color: #fff;
    /* background-color: #ef8b3c; */
    background-image: url("@/../public/img/oval-socialite.svg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
}
.oval-fool {
    background-color: transparent;
    border-color: transparent;
    text-align: center;
    height: 100%;
    width: 100%;
    color: #fff;
    /* background-color: #ef8b3c; */
    background-image: url("@/../public/img/oval-fool.svg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
}
.oval-weird {
    background-color: transparent;
    border-color: transparent;
    text-align: center;
    height: 100%;
    width: 100%;
    color: #fff;
    /* background-color: #ef8b3c; */
    background-image: url("@/../public/img/oval-weird.svg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
}
.oval-survivor {
    background-color: transparent;
    border-color: transparent;
    text-align: center;
    height: 100%;
    width: 100%;
    color: #fff;
    /* background-color: #ef8b3c; */
    background-image: url("@/../public/img/oval-survivor.svg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
}
</style>

